import { render, staticRenderFns } from "./NewGrahamsLawSIM.vue?vue&type=template&id=57e557e9&"
import script from "./NewGrahamsLawSIM.vue?vue&type=script&lang=ts&"
export * from "./NewGrahamsLawSIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports